import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";

const SnappManager = () => {
  const [saleUnits, setSaleUnits] = useState([]);
  const [selectedSaleUnitId, setSelectedSaleUnitId] = useState("");
  const { branchId } = useParams();
  const navigate = useNavigate();

  const fetchSaleUnits = async () => {
    try {
      const response = await apiMethod.getAllUnits(branchId);
      if (response.status === 200) {
        setSaleUnits(response.data);
      } else {
        methods.showErrors(response.messages);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSaleUnits();
  }, [branchId]);

  const changeSaleUnit = (unitId) => {
    setSelectedSaleUnitId(unitId);
    if (unitId) {
      navigate(`/sale/${branchId}/snappManager/SnappMenuGroups/${unitId}`);
    }
  };

  return (
    <>
      <div className='d-none d-lg-block'>
        <Link to={`/sale/${branchId}/#5`} className='text-start mb-3 link back-link'>
          <span><img src={back} className="" alt="return" /></span>
          بازگشت
        </Link>
      </div>
      <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
        <div>
          <Link to={`/sale/${branchId}/#5`} className='link back-link'>
            <span><img src={back} className="" alt="return" /></span>
          </Link>
          دسته‌بندی‌های اسنپ
        </div>
        <p className="date">{methods.currentDate()}</p>
      </div>
      <div className='saleheader d-none d-lg-block'>
        <p>دسته‌بندی‌های اسنپ
          <a href={`/sale/${branchId}/softwareGuide/#section16`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-question-circle"></i>
          </a>
        </p>
      </div>
      <div className="salemain">
        <div className='salesearchsection'>
          <div className='row g-1'>
            <div className='col-12 col-md-6 col-lg-4'></div>
            <div className='col-12 col-md-2 col-lg-4'></div>
            <div className='col-12 col-md-4 text-end'>
              <button
                onClick={() => { navigate(`/sale/${branchId}/snappManager/services`) }}
                className='btn btn-outline-purple custome-btn' type='button'> تعریف هزینه‌های اسنپ
              </button>
            </div>
          </div>
        </div>
        <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
          {saleUnits.map((item, index) => (
            <div className="col" key={index}>
              <div className="card h-100">
                <img src={methods.normalImage(item.imgSrc, 'unit')} alt={item.title} className="card-img-top p-2" style={{ height: '150px' }} />
                <div className="card-body">
                  <button
                    type="button"
                    className="btn bt-sm custome-btn btn-outline-purple w-100"
                    onClick={() => { changeSaleUnit(item.id) }}
                  >
                    {item.title}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default SnappManager;